export const currencyStr = currencyVal => {
  var currencyString = '';
  if (currencyVal || currencyVal === 0) {
    currencyString = '$' + currencyVal.toFixed(2);
  }
  return currencyString;
};
